export default __webpack_public_path__ + "static/media/free-i-phone-xr-fill-1-mask.a84d593a.svg";